import React from 'react';
import './FundraiserCardV2.scss';

const FundraiserCardV2 = ({ campaignData }) => {
	const avatars = campaignData?.avatars || [];
	const badge = campaignData?.beneficiary?.tax_benefit ? 'TAX BENEFIT' : null;
	const daysLeft = campaignData?.days_left;
	const peopleDonated = campaignData?.donors_count;
	const amount = campaignData?.amount_requested;
	const raised = campaignData?.raised?.raised;
	const progress = Math.min(100, Math.round((raised / amount) * 100));

	return (
		<div className={`fundraiser-card-v2`}>
			<div className="fcv2-img-section">
				<img
					src={campaignData?.gallery && campaignData?.gallery[0] ? campaignData?.gallery[0]?.cdn_path : '/images/default-campaign-picture.jpg'}
					alt="Fundraiser" className="fcv2-img" />
				{badge && <span className="fcv2-badge">{badge}</span>}
			</div>
			<div className="fcv2-content-section">
				<div className="fcv2-title" title={campaignData.title}>{campaignData.title}</div>
				<div className="fcv2-title-divider" />
				<div className="fcv2-stats-row">
					<div className="fcv2-stat">
						<div className="fcv2-stat-label">Funds Required</div>
						<div className="fcv2-stat-value">{amount.toLocaleString('en-IN')}</div>
					</div>
					<div className="fcv2-stat">
						<div className="fcv2-stat-label">Campaign end in</div>
						<div className="fcv2-stat-value fcv2-days-left">{daysLeft} days left</div>
					</div>
				</div>
				<div className="fcv2-progress-bar">
					<div className="fcv2-progress" style={{ width: `${progress}%` }} />
				</div>
				<div className="fcv2-donors-row">
					{peopleDonated && peopleDonated > 0 &&
					<div className="fcv2-avatars">
						{avatars.map((a, i) => (
							<img key={i} src={a} alt="avatar" className="fcv2-avatar" />
						))}
					</div>
					}
					{peopleDonated && peopleDonated > 0 &&
						<div className="fcv2-donors-text">{(peopleDonated / 1000)?.toFixed(1)}k people donated</div>
					}
				</div>
			</div>
		</div>
	);
};

export default FundraiserCardV2; 